var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"post-spacer",style:({ minHeight: `${_vm.height}px` })},[_c('div',{staticClass:"text-container",style:({ maxWidth: `${_vm.maxWidth}px`, width: `min(${_vm.maxWidth}px, 100vw)` })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }